<template>
	<div>
        <div class="customPopup">
		<div class="viewPlaceholder text-center">
        <img src="../../../../static/fxView/images/signOut.png" alt="Icon">
          <p>Are you sure you want to edit this field?</p>
          <div class="buttonSign d-flex">
            <a class="prism_btn greenBG minAuto" href="#" @click="$parent.showEditConfirm = '2';$parent.endSubscription($parent.subsciption_id)" v-if="pagename && pagename == 'SUBSCRIPTION-LISTING'">ok</a>
            <a class="prism_btn greenBG minAuto" href="#" @click="$parent.showEditConfirm = '2' ; $parent.editFunc($parent.getType)" v-else>ok</a>

		   <a class="prism_btn redBG minAuto" href="#" @click="$parent.showEditConfirm = '0'">cancel</a>
         </div>
        </div>
       </div>
       <div class="overlayPop"></div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'CONFIRMATION',
        mixins: [fxViewMixins],
        props:['pagename'],
        data() {
            return {
                pageTitle: this.$options.name,
            }
        },
        
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/confirmation.vue